import './ViewMessagePopup.scss'
import Popup, { ToolbarItem } from "devextreme-react/popup";
import { ViewMessagePopupProps } from '../types/ViewMessagePopupProps';
import { LoadPopupPanel } from "../../../../components";
import { useMarkMessageAsRead } from '../api/mark-message-as-read';
import { showErrorMessage } from '../../../../utils/messages';
import { useEffect } from 'react';
import ViewMessageForm from './ViewMessageForm';
import { useGetMessageThread } from '../api/get-message-thread';
import { MessageDetails } from '../types/MessageDetails';
import { MessageType } from '../types/MessageType';

export default function ViewMessagePopup(props: ViewMessagePopupProps) {

	const message = useGetMessageThread(props.notificationQueueID, props.orderID, props.kindOfOrder);
	const markAsRead = useMarkMessageAsRead(
		() => props.onMarkAsRead(),
		(error: string) => showErrorMessage(error));

	useEffect(() => {
		if (message.data) {
			if (message.data.currentMessage.isRead === false) {
				markAsRead.mutate(props.notificationQueueID);
			}
		}
	}, [message.data])

	const prevMessagesExist = (message.data?.previousMessages?.length ?? 0) > 0;

	return (
		<>
			<Popup
				title="View Message"
				visible={true}
				hideOnOutsideClick={true}
				onHiding={() => { props.onHidePopup(); }}
				width={700}
				height={630}
			>
				{
					message.data?.currentMessage.inboundFlag &&
					(props.disableSMS !== true || message.data.currentMessage.messageTypeID !== MessageType.SMS) &&
					<ToolbarItem
						options={{
							type: 'default',
							stylingMode: 'contained',
							text: 'Reply',
							icon: 'Inscyth-New-Message',
							onClick: () => {
								props.onReplyClicked();
							}
						}}
						widget="dxButton"
						location="after"
					/>
				}
				<ToolbarItem
					options={{
						type: 'normal',
						stylingMode: 'contained',
						text: 'Close',
						onClick: () => {
							props.onHidePopup();
						}
					}}
					widget="dxButton"
					location="after"
				/>

				{
					message.data &&
					<>
						<ViewMessageForm message={message.data.currentMessage} />
						<div className='previous-messages'>
							<div className="previous-messages-title">
								Previous Messages <i className="dx-icon dx-icon-Inscyth-Messages"></i>
							</div>
							{
								prevMessagesExist &&
								message.data?.previousMessages.map((prevMessage: MessageDetails) => {
									return (
										<div className='previous-message' key={prevMessage.notificationQueueID}>
											<ViewMessageForm message={prevMessage} />
										</div>
									)
								})
							}
							{
								message.data && !prevMessagesExist &&
								<div className='no-previous-messages'>
									No previous messages
								</div>
							}
						</div>
					</>
				}

				<LoadPopupPanel visible={message.isLoading}></LoadPopupPanel>

			</Popup>
		</>
	)
}
